// Practice-mode copy of backend/apps/games/penalties.py — keep in sync.
// Ranked games are decided on the server; this only runs when logged out.
//
// Zones:  0 1 2   (top)
//         3 4 5   (bottom)

export const ZONES = 6;
const BASE_READ_CHANCE = 0.08;
const READ_CHANCE_PER_GOAL = 0.025;
const MAX_READ_CHANCE = 0.45;

function readChance(goals) {
  return Math.min(BASE_READ_CHANCE + READ_CHANCE_PER_GOAL * goals, MAX_READ_CHANCE);
}

export function takeShot(shotZone, goals) {
  const keeperZone = Math.random() < readChance(goals)
    ? shotZone
    : Math.floor(Math.random() * ZONES);
  return { keeperZone, goal: keeperZone !== shotZone };
}

export const ZONE_LABELS = [
  'Canto superior esquerdo', 'Meio, em cima', 'Canto superior direito',
  'Canto inferior esquerdo', 'Meio, em baixo', 'Canto inferior direito',
];
